import React from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';
import FormHelperText from '@material-ui/core/FormHelperText';

import DatePicker from 'src/components/Common/Datepicker';

import { TPostAdInitialValues } from 'src/Types';

const ListingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const TitleWrapper = styled.div`
  margin: 24px 0 12px;
`;
const Title = styled.h1`
  font-size: 25px;
  line-height: 40px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary};
`;
const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
const Error = styled(FormHelperText)`
  color: ${({ theme }) => `${theme.colors.error} !important`};
  margin-bottom: 10px !important;
`;

type TProps = {
  className?: string;
  title?: string;
};

const AvailabilityDates: React.FunctionComponent<TProps> = ({ title, className }) => {
  const { values, errors, setFieldValue, setFieldTouched } = useFormikContext<
    TPostAdInitialValues
  >();

  return (
    <ListingSection className={className}>
      {title && (
        <TitleWrapper>
          <Title>{title}</Title>
        </TitleWrapper>
      )}
      <DateContainer>
        <DatePicker
          label="Start date"
          placeHolder="Enter starting date"
          selectedDate={values.startDate}
          handleBlur={() => setFieldTouched('startDate', true)}
          handleDateSelect={(date) => setFieldValue('startDate', date)}
          errorText={errors && errors.startDate}
          error={errors && errors.startDate}
        />
        <DatePicker
          label="End date"
          placeHolder="Enter ending date"
          selectedDate={values.endDate}
          minDate={values.startDate}
          handleBlur={() => setFieldTouched('endDate', true)}
          handleDateSelect={(date) => setFieldValue('endDate', date)}
          errorText={errors && errors.endDate}
          error={errors && errors.endDate}
        />
      </DateContainer>
      <Error>{errors?.startDate}</Error>
    </ListingSection>
  );
};

export default AvailabilityDates;
